import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { glyphs } from './assets/glyphs';
import {
  AdvancedMarker,
  Pin,
  InfoWindow,
  useAdvancedMarkerRef,
  useMap,
} from "@vis.gl/react-google-maps";
import api from './httpClient';

// Extracted InfoWindow content as its own memoized component.
// This prevents the content from causing the InfoWindow
// wrapper to re-evaluate its anchor/open state.
const InfoWindowContent = React.memo(({ point, lora, cell, loraStatus }) => {


  // An attempt to add class to the parents' parent
  // To mainuplate the position of the info window dependent on device type.
  useEffect(() => {
    const timer = setTimeout(() => {
      const el = document.querySelector('.info-container');
      if (el) {
        const iwContainer = el.closest('.gm-style-iw-c');
        if (iwContainer) {
          console.log("have a container");
          iwContainer.classList.remove('iw-offset-lora', 'iw-offset-cell');
          iwContainer.classList.add(lora ? 'iw-offset-lora' : 'iw-offset-cell');
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [lora]);

  async function buttonClick(url, device) {
    try {
      await api.post(url, { pump: device });
    } catch (error) {
      console.error('Request failed:', error);
    }
  }

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: '15px',
        ...(lora ? { minWidth: '400px' } : {}),
        color: 'black'
      }}
    >
      {lora && (
        <div className="cam-container">
          <h6>Pump Relay Live Stream</h6>
          <img
            src="https://cam.synergitech.com.au/stream"
            referrerPolicy='no-referer'
            alt="Site Camera"
            style={{
              width: "350px", height: "auto",
              borderRadius: "4px", border: '1px solid #ccc'
            }}
          />
        </div>
      )}

      <div className="info-container">
        <h6>Status</h6>
        <table className="pump-status">
          <tbody>
            <tr><td>Site name:</td><td>{point.siteName}</td></tr>
            <tr><td>Device ID:</td><td>{point.devId}</td></tr>
            {cell && (
              <>
                <tr><td>Pressure:</td><td>{point.data.pressure}</td></tr>
                <tr><td>Flow:</td><td>{point.data.flow}</td></tr>
              </>
            )}
            {lora && (
              <>
                <tr><td>Tank Full:</td><td>{loraStatus & 0x2 ? 'True' : 'False'}</td></tr>
                <tr><td>Pumping:</td><td>{loraStatus & 0x4 ? 'True' : 'False'}</td></tr>
                <tr><td>Emergency:</td><td>{loraStatus & 0x1 ? 'True' : 'False'}</td></tr>
                <tr>
                  <td>Switch Pump:</td>
                  <td>
                    <button
                      type="submit"
                      onClick={() => buttonClick("/pump_switch", point.devId)}
                    >
                      {(loraStatus & 0x4) ? "Off" : "On"}
                    </button>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {cell && (
          <Link
            to={`/site-data/${point.devId}?days=0&siteName=${encodeURIComponent(point.siteName)}`}
            state={point}
          >Go to site data</Link>
        )}
      </div>
    </div>
  );
});

// Separate memoized InfoWindow wrapper component
// This prevents the InfoWindow from re-mounting when the parent re-renders
const InfoWindowWrapper = React.memo(({ isOpen, marker, point, lora, cell, loraStatus, onClose }) => {
  if (!isOpen || !marker) return null;

  const lat = parseFloat(point.lat);
  const lng = parseFloat(point.lng);

  return (
      <InfoWindow
        key={`iw-${point.devId}`}
        position={{ lat, lng }}
        onClose={onClose}
        shouldFocus={false}
      >

      <InfoWindowContent
        point={point}
        lora={lora}
        cell={cell}
        loraStatus={loraStatus}
      />
      </InfoWindow>
  );
});

const Marker = ({point, isInfoWindowOpen, onMarkerClick, onCloseInfoWindow }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const map = useMap();
  
  const lat = parseFloat(point.lat);
  const lng = parseFloat(point.lng);
  const lngOffset = (lng - 50).toFixed(6);

  console.log('type of lng is: ', typeof(lng), ' with value ', lng);
  console.log('type of lngOffset is: ', typeof(lngOffset), ' with value ', lngOffset);

  const handleMarkerClick = useCallback(() => {
    // Center map on clicked marker
    if (map) {
      map.panTo({ lat, lng });
    }
    onMarkerClick();
  }, [onMarkerClick, map, lat, lng]);
  
  if (!lat || !lng) {
    console.error(`Marker Component: Lat or Long missing for point with devId: ${point.devId}`);
    return null;
  }

  const cell = point.type === 'cell' ? true : false;
  const lora = point.type === 'lora' ? true : false;
  const loraStatus = point.status;

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={{ lat, lng }}
        title={point.title}
        onClick={handleMarkerClick}
      >
        {cell && glyphs.brick_cell}
        {lora && glyphs.pump_lora({ statusByte: loraStatus })}
      </AdvancedMarker>

      <InfoWindowWrapper
        isOpen={isInfoWindowOpen}
        marker={marker}
        point={point}
        lora={lora}
        cell={cell}
        loraStatus={loraStatus}
        onClose={onCloseInfoWindow}
      />
    </>
  );
};

export default Marker;